export default __webpack_public_path__ + "static/estimator-acanthaceae-f9c3f9309ee90f4e4dcc400c4b37ae95.svg";